<zimmerer-route-ion-wrapper class="ion-page">

  <div class="threecol" fxLayout="column" fxLayoutAlign.gt-md="center center">

    <div class="main-col withBottomPadding" [class.withTopPadding]="MobileService.isMobile"
      [class.noSlider]="!hasSliderImages" fxLayout="column" fxLayoutGap="20px">

      <image-slider [fxHide]="!hasSliderImages" [page]="'profile'" fxHide.lt-lg></image-slider>

      <div fxLayout="row" fxLayout.lt-lg="column">
        <!-- nav menu -->
        <div fxHide.lt-lg class="min-menu-wrapper" fxFlex="15">
          <app-profile-nav></app-profile-nav>
        </div>

        <div id="profileComponentContent" fxFlex="85" fxFlex.xs="100" fxLayout="column" *ngIf="user$ | async as user">

          <app-business-new-profile (createNewProfile)="newCompanyProfile('CARPENTER')"
            (createNewProfileCarpenterPlus)="newCompanyProfile('CARPENTER_PLUS')"
            (createNewProfileOther)="newCompanyProfile('OTHER')" *ngIf="!user.company_profile">
          </app-business-new-profile>

          <app-create-company-profile *ngIf="user.company_profile && !user.company_profile.is_published">
          </app-create-company-profile>

          <app-company-profile *ngIf="user.company_profile && user.company_profile.is_published"></app-company-profile>

        </div>
      </div>

    </div>
  </div>

  <app-footer></app-footer>

</zimmerer-route-ion-wrapper>